// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const CombinationOut = zod.object({
  "asset_ids": zod.array(zod.uuid()),
  "names": zod.array(zod.string()),
  "why": zod.string()
});

export type CombinationOut = zod.input<typeof CombinationOut>;
export type CombinationOutOutput = zod.output<typeof CombinationOut>;
